import { render, staticRenderFns } from "./TipsModal.vue?vue&type=template&id=e433c70a&"
import script from "./TipsModal.vue?vue&type=script&lang=js&"
export * from "./TipsModal.vue?vue&type=script&lang=js&"
import style0 from "./TipsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports